import { v4 as uuidv4 } from 'uuid';

import { saveOAuthReturnUrl } from 'APP/Tasks/authorization/authorization';
import * as authModel from 'APP/model/auth/authModel';
import { ModelError } from 'APP/model/error/errors/ModelError';

export interface IRedirectToADAuthResult {
  isSuccess: boolean;
  error?: ModelError;
}

interface IRedirectToADAuthUrlParams {
  isNavigateBackDisabled?: boolean;
}

export const redirectToADAuth = async (
  email = '',
  params?: IRedirectToADAuthUrlParams
): Promise<IRedirectToADAuthResult> => {
  try {
    const authUrlData = await authModel.getAuthUrl();
    if (!authUrlData?.authUrl) {
      return { isSuccess: false };
    }

    const oauthStateId = uuidv4();
    saveOAuthReturnUrl(oauthStateId);

    const redirectUri = new URL(window.location.origin + window.location.pathname).href;

    const authUrlObject = new URL(authUrlData.authUrl);

    authUrlObject.searchParams.set('redirect_uri', redirectUri);
    authUrlObject.searchParams.set('back_uri', redirectUri);
    authUrlObject.searchParams.set('login_hint', email);
    authUrlObject.searchParams.set('support_email', authUrlData.supportEmail);
    authUrlObject.searchParams.set('state', oauthStateId);

    if (params?.isNavigateBackDisabled) {
      authUrlObject.searchParams.set('is_navigate_back_disabled', 'true');
    }

    window.location.replace(authUrlObject.href);
    return { isSuccess: true };
  } catch (error: any) {
    return { isSuccess: false, error: error as ModelError };
  }
};
